import React, { useEffect, useState } from "react";
import "./loginpage.scss";
import { useNavigate } from "react-router-dom";
import { Formik, Form, Field } from "formik";
import { AuthServices } from "../services/AuthServices";
import ReCAPTCHA from "react-google-recaptcha";
import { useDispatch } from "react-redux";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { selectRole, toggleUser } from "../redux/roleSlice";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { CircularProgress } from "@mui/material";
import { toast } from "react-toastify";
import * as yup from "yup";
import ChangePassword from "../appbar/ChangePassword";
import { getDeviceInfo } from "../utils/getDeviceInfo";
import { handleApiErrorResponses } from "../utils/ApisErrorHandling";
export const Loginpage = ({ setSignup, setForgotPassword }) => {
  const navigate = useNavigate();
  const [verified, setVerified] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [openChangePassword, setOpenChangePassword] = useState(false);
  const [deviceInfo, setDeviceInfo] = useState({});

  const dispatch = useDispatch();

  const signUp = () => {
    setSignup(true);
  };
  const handleTogglePassword = () => {
    setShowPassword(!showPassword);
  };
  const forgotPassword = () => {
    setForgotPassword(true);
  };

  useEffect(() => {
    const fetchInfo = async () => {
      const info = await getDeviceInfo();
      setDeviceInfo(info);
    };
    fetchInfo();
  }, []);

  const onCaptchaChange = (value) => {
    setVerified(true);
  };

  const initialValues = {
    email: "",
    password: "",
    keepSignedIn: false,
  };

  const errorValidation = yup.object({
    email: yup.string().email().required("Required Field !"),
    password: yup.string().required("Password is required !"),
  });

  const handleSubmit = async (values) => {
    try {
      setIsSubmitting(true);

      const loginData = {
        ...values,
        ...deviceInfo,
      };

      let response = await AuthServices.login(loginData);
      if (response.data) {
        if (response.data.isDeactivated) {
          toast.error("This sub user is deactivated, please contact admin");
        } else {
          dispatch(selectRole(response?.data?.roles[0]));
          dispatch(toggleUser());
          let userDetails = JSON.stringify(response?.data);
          localStorage.setItem("userDetails", userDetails);

          const filteredDutRole = response?.data?.roles?.filter(
            (role) => role.roleId === 13,
          );
          const filteredOnboardingRole = response?.data?.roles?.filter(
            (role) => role.roleId === 14,
          );
          toast.success("Login Successful");
          setTimeout(() => {
            response?.data?.hospital?.status === "INACTIVE"
              ? navigate("/under-review")
              : response?.data?.hospital?.id
                ? navigate("/dashboard/case-status")
                : filteredDutRole?.length > 0 ||
                    filteredOnboardingRole?.length > 0
                  ? navigate("dashboard/manage-rpa-logs")
                  : navigate("/dashboard/ActiveCases");
          }, 1500);
        }
      }
    } catch (error) {
      window.alert(error?.response?.data?.error);
    }
    setIsSubmitting(false);
  };

  return (
    <div className="main1">
      <Formik
        initialValues={initialValues}
        validationSchema={errorValidation}
        onSubmit={handleSubmit}
      >
        {({ errors, touched, values, setFieldValue }) => (
          <Form className="form-container">
            <h2 style={{ marginBottom: "5px" }}>Let's get you started!</h2>
            <div style={{ marginTop: "-10px", paddingTop: "10px" }}>
              <span style={{ color: "#797979" }}>Welcome to Settlemed</span>
            </div>
            <hr
              style={{
                width: "100%",
                height: "1px",
                color: "rgba(228, 228, 228, 1)",
                marginTop: "25px",
              }}
            />

            <div>
              <div className="label" style={{ marginBottom: "15px" }}>
                <span>Email Id</span>
                <Field
                  name="email"
                  className="input"
                  placeholder="Enter your email"
                  // style={{
                  //   width: "458px",
                  //   height: "40px",
                  //   borderRadius: "8px",
                  //   border: "1px solid rgba(228, 228, 228, 1)",
                  //   padding: "12px",
                  //   marginTop: "8px",
                  //   marginBottom: "8px",
                  // }}
                />
                {touched.email && errors.email && (
                  <span className="error">{errors.email}</span>
                )}
              </div>
              {/* <div className="label">
                <span>Enter Password</span>
                <Field
                  name="password"
                  type="password"
                  className="input"
                  placeholder="Enter your password"
                  // style={{
                  //   width: "458px",
                  //   height: "40px",
                  //   borderRadius: "8px",
                  //   border: "1px solid rgba(228, 228, 228, 1)",
                  //   padding: "12px",
                  //   marginTop: "8px",
                  //   marginBottom: "8px",
                  // }}
                />
                {touched.password && errors.password && (
                  <span className="error">{errors.password}</span>
                )}
              </div> */}
              <div className="label">
                <span>Enter Password</span>
                <div style={{ position: "relative" }}>
                  <Field
                    name="password"
                    type={showPassword ? "text" : "password"}
                    className="input w-[92%]"
                    placeholder="Enter your password"
                  />
                  <span
                    onClick={handleTogglePassword}
                    style={{
                      position: "absolute",
                      right: "10px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                      color: "#797979",
                    }}
                  >
                    {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                  </span>
                </div>
                {touched.password && errors.password && (
                  <span className="error">{errors.password}</span>
                )}
              </div>
            </div>

            <div
              style={{
                display: "flex",
                width: "159px",
                height: "29px",
                gap: "4px",
                justifyContent: "center",
                marginLeft: "-13px",
              }}
            >
              <div className="error-icon-wrapper">
                <ErrorOutlineIcon className="error-icon" />
              </div>
              <button
                type="button"
                className="forgot-password-link"
                onClick={forgotPassword}
              >
                Forgot Password
              </button>
            </div>

            <div
              className="keep-signed-in"
              style={{ width: "100%", display: "flex", alignItems: "center" }}
            >
              <Field
                type="checkbox"
                name="keepSignedIn"
                id="keepSignedIn"
                className="checkbox"
              />
              <label htmlFor="keepSignedIn" className="keep-signed-in-label">
                Keep me signed in
              </label>
            </div>
            <div className="captcha-box">
              {verified ? (
                <ReCAPTCHA
                  sitekey="6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI"
                  onChange={onCaptchaChange}
                />
              ) : null}
            </div>
            {isSubmitting ? (
              <div className="flex justify-center">
                <CircularProgress />
              </div>
            ) : (
              <button
                disabled={isSubmitting}
                type="submit"
                className="sign-in-button"
              >
                GET STARTED
              </button>
            )}
          </Form>
        )}
      </Formik>
      <span
        style={{
          font: "Inter",
          fontWeight: "600",
          fontSize: "14px",
          lineHeight: "20px",
          letterSpacing: "-0.4px",
          alignItems: "center",
          color: "rgba(121, 121, 121, 1)",
        }}
      >
        Don't have an account?{" "}
        <button className="text-button" onClick={signUp}>
          Sign up here
        </button>
      </span>
      {/* {openChangePassword && <ChangePassword setOpen={setOpenChangePassword} />} */}
    </div>
  );
};
